class FileStorageService {
  constructor() {
    this.storage = new Map();
    this.maxFileSize = 10 * 1024 * 1024; // 10MB
    this.allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
  }

  async uploadFile(file, options = {}) {
    try {
      // Validate file
      const validation = this.validateFile(file);
      if (!validation.valid) {
        throw new Error(validation.error);
      }

      // Generate unique filename
      const fileId = this.generateFileId();
      const fileName = options.fileName || file.name;
      const fileExtension = fileName.split('.').pop();
      const uniqueFileName = `${fileId}.${fileExtension}`;

      // Mock file upload - in real implementation this would upload to cloud storage
      const fileData = {
        id: fileId,
        originalName: fileName,
        fileName: uniqueFileName,
        size: file.size,
        type: file.type,
        uploadedAt: new Date(),
        url: URL.createObjectURL(file) // For demo purposes
      };

      this.storage.set(fileId, fileData);
      
      console.log('File uploaded:', fileData);
      return fileData;
    } catch (error) {
      console.error('File upload failed:', error);
      throw error;
    }
  }

  async getFile(fileId) {
    return this.storage.get(fileId) || null;
  }

  async deleteFile(fileId) {
    const file = this.storage.get(fileId);
    if (file) {
      // Revoke object URL to free memory
      if (file.url && file.url.startsWith('blob:')) {
        URL.revokeObjectURL(file.url);
      }
      return this.storage.delete(fileId);
    }
    return false;
  }

  async listFiles() {
    return Array.from(this.storage.values());
  }

  validateFile(file) {
    if (!file) {
      return { valid: false, error: 'No file provided' };
    }

    if (file.size > this.maxFileSize) {
      return { valid: false, error: 'File size exceeds maximum allowed size' };
    }

    if (!this.allowedTypes.includes(file.type)) {
      return { valid: false, error: 'File type not allowed' };
    }

    return { valid: true };
  }

  generateFileId() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
  }

  getFileUrl(fileId) {
    const file = this.storage.get(fileId);
    return file ? file.url : null;
  }

  async updateFileMetadata(fileId, metadata) {
    const file = this.storage.get(fileId);
    if (file) {
      const updated = { ...file, ...metadata, updatedAt: new Date() };
      this.storage.set(fileId, updated);
      return updated;
    }
    return null;
  }
}

const fileStorageService = new FileStorageService();
export default fileStorageService;